
export interface UserPermInquiryState {
  userPermissionTargets: any[];
}

export const initialState: UserPermInquiryState = {
  userPermissionTargets: []
};
